import React from "react";
import { Link } from "react-router-dom";
import BlueLayout from "../layouts/BlueLayout";
import Curve from "../components/global/Curve";
import { AppInput } from "../components/global/AppInput";
import { useForm } from "../hooks/useForm";
import { useDispatch } from "react-redux";
import { login } from "../actions/userActions";

export const SignUpScreen = () => {

  const dispatch = useDispatch();

  const { formData, handleInput } = useForm({
    email: "",
    password: "",
    name: "",
    confirmPassword: ""
  });

  function onSubmit(e) {
    e.preventDefault();
    dispatch(login(formData.email, formData.password))
  }

  return (
    <BlueLayout>
      <section className="container lg:flex lg:justify-between gap-16 lg:pt-32 pb-10 lg:pb-40">
        <div className="flex-grow max-w-md">
          <div>
            <h1 className="text-4xl">Create an account</h1>
            <div className="mb-10">
              <p>Already an account?</p>
              <Link
                to="/login"
                className="block mt-2 ml-2 text-canton-jadesheen font-bold"
              >
                Log In
              </Link>
            </div>
          </div>
          <form autoComplete="off" onSubmit={onSubmit}>
            <AppInput
              id="name"
              name="name"
              label="Name"
              value={formData.name}
              onChange={handleInput}
            />
            <AppInput
              id="email"
              name="email"
              label="Email"
              type="email"
              value={formData.email}
              onChange={handleInput}
            />
            <AppInput
              id="password"
              name="password"
              label="Password"
              type="password"
              value={formData.password}
              onChange={handleInput}
            />
            <AppInput
              id="confirmPassword"
              name="confirmPassword"
              label="Confirm Password"
              type="password"
              value={formData.confirmPassword}
              onChange={handleInput}
            />
            <p>
              <Link to="/" className="block text-canton-jadesheen font-bold">
                Forgot password?
              </Link>
            </p>
            <button
              type="submit"
              className="bg-canton-jadesheen py-3 px-9 mt-3 font-semibold"
            >
              Log in
            </button>
          </form>
        </div>
        <div className="hidden lg:block">
          <img src={require('../assets/images/login/science-teacher.png')} alt="science-girl" />
        </div>
      </section>
      <Curve color="--var-color-vrc-night-blue" />
    </BlueLayout>
  );
};
